import { Component, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ProjectConfiguration, ProjectId } from '@models/ProjectConfiguration';
import { UserProfile } from '@models/UserProfile';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Canon } from '@models/Canon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { SynchronizerService } from '../synchronizer.service';
import { MatListModule } from '@angular/material/list';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { CommonTasksService } from '../common-tasks.service';
import { BibleNavigatorComponent } from './bible-navigator/bible-navigator.component';
import { VerseDisplayComponent } from './verse-display/verse-display.component';

@Component({
  selector: 'app-workspace',
  imports: [CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatSelectModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    RouterModule,
    VerseDisplayComponent,
    BibleNavigatorComponent,
  ],
  templateUrl: './workspace.component.html',
  styleUrl: './workspace.component.scss'
})
export class WorkspaceComponent implements OnInit {
  form: FormGroup;

  constructor(private formBuilder: FormBuilder,
    public synchronizerService: SynchronizerService,
    public dialog: MatDialog,
    public commonTasks: CommonTasksService
  ) {
    this.form = this.formBuilder.group({
      canon: new FormControl(this.project?.canons),
      project_id: new FormControl(this.user?.projects)
    });

    this.form.get('canon')?.valueChanges.subscribe(() => {
      this.canonChanged();
    });

    this.form.get('project_id')?.valueChanges.subscribe(() => {
      this.projectChanged();
    });
  }

  ngOnInit() {


    this.synchronizerService.position$.subscribe(position => {
      if (position) {
        this.form.setValue({
          canon: position.canon,
          project_id: position.project_id
        });
      } else {
        const project = this.user?.projects.next().value as ProjectConfiguration;
        if (project) {
          this.form.setValue({
            canon: project.fallbackCanon(),
            project_id: project.id
          });
        }
      }
    });

  }

  get project(): ProjectConfiguration | undefined {
    return this.synchronizerService.currentProject;
  }

  get user(): UserProfile | undefined {
    return this.synchronizerService.user$.value;
  }

  canonChanged() {
    this.synchronizerService.setCanon(this.form.get('canon')?.value as Canon);
    // if (this.user?.currentPosition) {
    //   this.user.currentPosition.canon = this.form.get('canon')?.value;
    //   this.api.forceVerseUpdate(this.user.currentPosition.ref);
    // }
  }

  projectChanged() {
    const currentCanon = this.form.get('canon')?.value as Canon;
    const pid = this.form.get('project_id')?.value as ProjectId;
    const project = this.user?.project(pid);
    if (project && this.user) {
      if (this.synchronizerService.currentPosition === undefined) {
        this.synchronizerService.setToFallbackPosition();
      }
      let canon: Canon;
      if (this.user?.project(pid)?.hasCanon(currentCanon)) {
        canon = currentCanon;
      } else {
        canon = project.fallbackCanon();
      }
      this.synchronizerService.setProject(pid, canon);
      this.form.controls['canon'].setValue(canon);
    } else {
      console.error(`No project available for ${pid}. Setting to fallback position.`);
      this.synchronizerService.setToFallbackPosition();
    }
  }

}
